import { useRef, useState } from 'react';
import SoundVolumeIcon from './soundVolumeIcon';
import { useAppDispatch, useAppSelector } from 'redux-share/hooks';
import { sendFluentLog, volumeLog } from '../../../../../logs';
import { createSettings } from 'redux-share/actions/user.actions';
import { setUserSettings } from 'redux-share/slices/userSlice';
import { handleChangeSoundVolume } from 'redux-share/actions/controller.actions';
import store from 'redux-share/store';
import { conditions } from 'helpers';
import { ConditionName } from 'interfaces';
import { shallowEqual } from 'react-redux';
import dynamic from "next/dynamic";

const ControllbarTooltip = dynamic(() => import("../../mainComponent/footer/controllbar/controllbarTooltip"));

const SoundVolume = () => {

    const [showTooltip, setShowTooltip] = useState<boolean>(false);

    const dispatch = useAppDispatch();
    const { settings } = useAppSelector(({ user: { settings } }) => ({ settings }), shallowEqual);
    useAppSelector(({ videoData: { ads } }) => ({ ads }), shallowEqual);

    const primaryVolumeRef = useRef<number>(settings.volume);

    const handleMouseUp = () => {
        if (primaryVolumeRef.current !== settings.volume) {
            const { settings } = store.getState().user;
            sendFluentLog(volumeLog(primaryVolumeRef.current, settings.volume));
            primaryVolumeRef.current = settings.volume;
            createSettings({ ...settings, volume: settings.volume });
            dispatch(setUserSettings({...settings, volume:settings.volume}))
        }
    }

    const handleMute = (type:string) => {
        const { settings } = store.getState().user;
        if(type === "mute") {
            handleChangeSoundVolume(0);
            sendFluentLog(volumeLog(settings.volume, 0));
            createSettings({ ...settings, volume: 0 });
        } else {
            sendFluentLog(volumeLog(settings.volume, 100));
            handleChangeSoundVolume(100);
            createSettings({...settings, volume: 100});
        }
    }

    return (
        <div className={`${conditions(ConditionName.isPlayingAd) && `pl-absolute ${conditions(ConditionName.isTouchScreen) ? "pl-bottom-2 pl-left-[15px]" : "pl-bottom-3 pl-left-4"}`} pl-inline-flex pl-items-center pl-gap-2 pl-sound-icon`}>
            {!conditions(ConditionName.isTouchScreen) && (
                <input
                    onMouseUp={handleMouseUp}
                    type="range"
                    min="0"
                    max="100"
                    value={settings.volume}
                    onChange={(event) => handleChangeSoundVolume(+event.target.value)}
                    className="pl-soundVolume pl-cursor-pointer"
                    style={{ background: `linear-gradient(to right, white ${settings.volume}%, rgba(255,255,255,0.3) 0)` }}
                />

            )}
            <div className='pl-relative pl-flex pl-items-center'>
                <SoundVolumeIcon 
                    onClick={() => conditions(ConditionName.hasSound) ? handleMute("mute") : handleMute("unmute")}
                    onDoubleClick={(event: any) => event.stopPropagation()}
                    onMouseOver={() => !conditions(ConditionName.isTouchScreen) && setShowTooltip(true)}
                    onMouseLeave={() => !conditions(ConditionName.isTouchScreen) && setShowTooltip(false)}
                />
                {showTooltip && !conditions(ConditionName.isPlayingAd) && <ControllbarTooltip className={`${conditions(ConditionName.isStaticFormat) && "pl-right-[-40px]"}`} title={`${conditions(ConditionName.hasSound) ? "با صدا" : "بی صدا"} (m)`} />}
            </div>
        </div>
    )
}

export default SoundVolume;